const trainingModeColors = {
  1: "blue",
  2: "orange",
  3: "red",
};

export default trainingModeColors;
